import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as PageSettingStore from '../../app/store/PageSettingStore';

const LoadAppContent = () => {
    const dispatch = useDispatch();
    const appContentProgramId = useSelector(state => state.pageSettings.appConfig?.appContentProgramId);
    const appContent = useSelector(state => state.pageSettings.appContent);

    React.useEffect(() => {
        if (appContentProgramId && !appContent) {
            dispatch(PageSettingStore.actionCreators.getAppContent(appContentProgramId));
        }
    }, [appContent, appContentProgramId, dispatch]);

    return null;
};

export default LoadAppContent;
